import WeatherApiQueryComponent from './WeatherApiQueryComponent';
import type { IQueryDataShow } from './WeatherApiQueryComponent';

export default WeatherApiQueryComponent;
export type {
    IQueryDataShow
};